import { render, staticRenderFns } from "./ProductCounters.vue?vue&type=template&id=74a0ce5c&scoped=true&"
import script from "./ProductCounters.vue?vue&type=script&lang=js&"
export * from "./ProductCounters.vue?vue&type=script&lang=js&"
import style0 from "./ProductCounters.vue?vue&type=style&index=0&id=74a0ce5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a0ce5c",
  null
  
)

export default component.exports